import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { Row, Col, Card, CardBody, CardTitle, CardText } from 'reactstrap';
import { resetSuggestion, loadSuggestion } from '../../../redux';
import { Loader, ApplicationDetails } from '../../../components';
import { Utils } from '../../../services';
import { countryDisplayName } from '../../../services/countryIso';

import './ShiftSuggestion.css';

import user_avatar from '../../../assets/images/user_avatar.webp';

const ShiftSuggestion = ({ userId }) => {
    const { t, i18n } = useTranslation();
    const dispatch    = useDispatch();

    const { isLoadingSuggestion, suggestion } = useSelector(state => state.shifts);

    useEffect(() => {
        if (userId)
            dispatch(loadSuggestion(userId));
        else
            dispatch(resetSuggestion());
    }, [dispatch, userId]);

    const current_lng = (i18n.language) ? i18n.language.substr(0, 2) : null;

    return (
        <div className="ShiftSuggestion">
            {(isLoadingSuggestion || !suggestion) ? (
                <Card>
                    <CardBody>
                        <Loader />
                    </CardBody>
                </Card>
            ) : (
                <Row className="my-0">
                    <Col>
                        <Card>
                            <CardBody>
                                <CardTitle>
                                    <i className="fa fa-user"></i>&nbsp;
                                    { suggestion.fullname }
                                </CardTitle>
                                <CardText tag="div">
                                    <div className="d-flex flex-column justify-center items-center gap-0">
                                        <div>
                                            <div className="avatar-wrapper">
                                                <img className="avatar" src={suggestion.avatar || user_avatar} alt="User avatar" />
                                            </div>
                                        </div>
                                        <div className="w-100 mt-3 mb-3">
                                            { suggestion.activities?.length > 0 && (
                                                <div className="text-center mb-3">
                                                    { suggestion.activities?.map(activity => <div key={activity.id} className="badge badge-light mr-2"> {activity.name[current_lng]}</div>) }
                                                </div>
                                            )}
                                            <div><b>{t('users.email')}</b>: { suggestion.email }</div>
                                            {suggestion.fix_phone && (<div><b>{t('users.fix_phone')}</b> : { suggestion.fix_phone }</div>)}
                                            {suggestion.mobile_phone && (<div><b>{t('users.mobile_phone')}</b> : { suggestion.mobile_phone }</div>)}
                                            {suggestion.pro_phone && (<div><b>{t('users.pro_phone')}</b> : { suggestion.pro_phone }</div>)}
                                            {suggestion.fax && (<div><b>{t('users.fax')}</b> : { suggestion.fax }</div>)}
                                            {suggestion.address && (<div>{ suggestion.address }</div>)}
                                            {suggestion.city && (<div>{ suggestion.zip } {suggestion.city }</div>)}
                                            {suggestion.country && (<div>{ countryDisplayName(suggestion.country, i18n.language) }</div>)}
                                        </div>
                                        {suggestion.availabilities?.length > 0 && (
                                            <div className="w-100 mb-3">
                                                <div><b>{t('users.availabilities')}</b></div>
                                                <table className="table">
                                                    <tbody>
                                                    {suggestion.availabilities.map(availability => (
                                                        <tr key={availability.id}>
                                                            <td align="left">{Utils.formatLocalizedDateTime(availability.start_at, i18n.language, 'LLL')}&nbsp;</td>
                                                            <td align="center">&#x279F;&nbsp;</td>
                                                            <td align="right">{Utils.formatLocalizedDateTime(availability.stop_at, i18n.language, 'LLL')}</td>
                                                        </tr>
                                                    ))}
                                                    </tbody>
                                                </table>
                                            </div>
                                        )}
                                        {suggestion.sectors?.length > 0 && (
                                            <div className="w-100 mb-3">
                                                <div><b>{t('users.sectors')}</b></div>
                                                {suggestion.sectors.map(sector => Utils.localized_or_fallback(sector.name, current_lng)).join(', ')}
                                            </div>
                                        )}
                                    </div>
                                </CardText>
                                { suggestion?.applications?.length > 0 &&
                                    <CardText tag="div">
                                        { suggestion?.applications?.map(application => (
                                            <div key={ application.id }>
                                                <ApplicationDetails column readOnly application={ application } hideStatus />
                                            </div>
                                        ))}
                                    </CardText>
                                }
                            </CardBody>
                        </Card>
                    </Col>
                </Row>
            )}
        </div>
    );

};

export default ShiftSuggestion;
